import React from 'react';
import randomstring from 'uuid/v4';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

class Activity extends React.Component {

    render() {
        const { last_instance_opened, onClose, anchorEl } = this.props;
        return (
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={true}
                onClose={() => onClose(null)}
                PaperProps={{
                    style: {
                        maxHeight: 48 * 4.5,
                    },
                }}
            >
                {
                    last_instance_opened.slice(0, last_instance_opened.length - 1).map(option => (
                        <MenuItem key={randomstring()} onClick={() => onClose(option)}>
                            {
                                option.family + " " + option.name + " [" + option.id + "]"
                            }
                        </MenuItem>
                    ))
                }
            </Menu>
        );
    }
}

export default Activity;



// WEBPACK FOOTER //
// ./src/components/complex/forms/LastInstances.js